import PaperError from '@errors/PaperError';

export const NAME = 'NonDisplayableError';

export default class NonDisplayableError extends PaperError {
    public readonly hiddenMessage: string;

    public constructor(message = '') {
        super('', NAME);
        this.hiddenMessage = message;
    }

    public toString(): string {
        return `${this.name}: ${this.hiddenMessage}`;
    }
}
